<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        class="mb-2"
      >
        <h3 class="mb-0">
          Site Details
        </h3>
        <small class="text-muted">
          Enter Site Information Details.
        </small>
      </b-col>
      <b-col
        cols="12"
      >
        <b-form-group
          label="Search for the site"
          label-for="siteInput"
        >
          <vue-autosuggest
            v-model="query"
            :suggestions="filteredOptions"
            :get-suggestion-value="getSuggestionValue"
            :input-props="{id:'autosuggest__input',class:'form-control', placeholder:'Hemköp, Karlaplan 13, 115 20, Östermalm, Stockholm, SWE'}"
            @focus="focusMe"
            @click="clickHandler"
            @input="onInputChange"
            @selected="onSelected"
          >
            <template slot-scope="{suggestion}">
              <span class="my-suggestion-item">{{ suggestion.item.label }}</span>
            </template>
          </vue-autosuggest>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <p />
      </b-col>

      <b-col md="6">
        <b-form-group
          label="Site Name"
          label-for="siteInput"
        >
          <validation-provider
            #default="{ errors }"
            name="Site Name"
            rules="required"
          >
            <b-form-input
              id="siteInput"
              v-model="newSite.details.name"
              :state="newSite.details.name.length > 0 "
              placeholder="Ica Lindhagen / Circle K Solna "
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- Address -->
      <b-col md="6">
        <b-form-group
          label="Address"
          label-for="address"
        >
          <validation-provider
            #default="{ errors }"
            name="Address"
            rules="required"
          >
            <b-form-input
              id="address"
              v-model="newSite.details.address"
              :state="newSite.details.address.length > 0"
              placeholder="Address"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- Postal Code -->
      <b-col md="6">
        <b-form-group
          label="Zip Code"
          label-for="zipInput"
        >
          <validation-provider
            #default="{ errors }"
            name="Zip Code"
            rules="required"
          >
            <b-form-input
              id="zipInput"
              v-model="newSite.details.zip_code"
              :state="newSite.details.zip_code.length > 0"
              placeholder="Zip Code"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- City -->
      <b-col md="6">
        <b-form-group
          label="City"
          label-for="cityInput"
        >
          <validation-provider
            #default="{ errors }"
            name="City"
            rules="required"
          >
            <b-form-input
              id="cityInput"
              v-model="newSite.details.city"
              placeholder="City"
              :state="newSite.details.city.length > 0"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- Sub Region  -->
      <b-col md="6">
        <b-form-group
          label="Sub Region"
          label-for="regionInput"
        >
          <validation-provider
            name="subRegion"
          >
            <b-form-input
              id="subRegionInput"
              v-model="newSite.details.subRegion"
              placeholder="Sub Region"
            />
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- Region -->
      <b-col md="6">
        <b-form-group
          label="Region"
          label-for="regionInput"
        >
          <validation-provider
            #default="{ errors }"
            name="region"
            rules="required"
          >
            <b-form-input
              id="regionInput"
              v-model="newSite.details.region"
              placeholder="Region"
              :state="newSite.details.region.length > 0"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- Country-->
      <b-col md="6">
        <b-form-group
          label="Country"
          label-for="countryInput"
        >
          <validation-provider
            #default="{ errors }"
            name="Country"
            rules="required"
          >
            <b-form-input
              id="countryInput"
              v-model="newSite.details.country"
              placeholder="Country"
              :state="newSite.details.country.length > 0"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- select site type
      <b-col md="6">
        <b-form-group
          label="Type of Site"
          label-for="siteTypesInput"
        >
          <validation-provider
            #default="{ errors }"
            name="siteTypes"
          >
            <v-select
              v-model="types"
              multiple
              :options="siteTypesOptions"
              label="type"
              placeholder="Select Type of Site"
            >
              <template #option="{ type }">
                <span> {{ type }}</span>
              </template>
            </v-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      -->

      <!-- Tags -
      <b-col md="12">
        <b-form-group
          label="Tags"
          label-for="siteTagsInput"
        >
          <b-form-tags
            v-model="tags"
            input-id="tags-basic"
            class="mb-2"
            remove-on-delete
            separator=" "
          />
        </b-form-group>

      </b-col>
      -->
    </b-row>
    <b-row
      v-if="newSite.details.AWSLongLat.length > 0"
      class="mt-2"
    >

      <b-col>
        <site-map
          :coordinates="newSite.details.AWSLongLat"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Geo } from 'aws-amplify'
import { VueAutosuggest } from 'vue-autosuggest'
import { ValidationProvider } from 'vee-validate'
// import vSelect from 'vue-select'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  // BFormTags,
} from 'bootstrap-vue'
import SiteMap from './SiteMap.vue'

export default {
  components: {
    // vSelect,
    ValidationProvider,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    // BFormTags,
    VueAutosuggest,
    SiteMap,
  },
  props: {
    newSite: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      types: [],
      siteTypesOptions: [],
      siteTypesOptionsLoaded: false,
      tags: [],
      tagsOptions: [],
      tagsOptionsLoaded: false,
      filteredOptions: [],
      query: '',
    }
  },
  watch: {
    types(newVal) {
      this.$emit('siteTypes', newVal)
    },
    newSite(newVal) {
      this.$emit('tags', newVal)
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    clickHandler(item) {
      //  console.log(item)
      // event fired when clicking on the input
    },
    onSelected(item) {
      this.newSite.details.AWSLongLat = []
      // this.site_name = item.item.label.split(',')[0]
      this.newSite.details.AWSLocationLabel = item.item.label
      this.newSite.details.address = item.item.label.split(',')[1].trim()
      this.newSite.details.city = item.item.municipality
      this.newSite.details.zip_code = item.item.postalCode
      this.newSite.details.subRegion = item.item.subRegion
      this.newSite.details.region = item.item.region
      this.newSite.details.AWSLongLat = item.item.geometry.point
      switch (item.item.country) {
        case 'SWE':
          this.newSite.details.country = 'Sweden'
          break
        case 'FIN':
          this.newSite.details.country = 'Finland'
          break
        default:
      }
    },
    /**
     * This is what the <input/> value is set to when you are selecting a suggestion.
     */
    getSuggestionValue(suggestion) {
      return suggestion.item.label
    },
    // eslint-disable-next-line no-unused-vars
    focusMe(e) {
      // console.log(e)
    },
    async onInputChange(text) {
      if (text === '' || text === undefined) {
        return
      }
      if (text.length > 3) {
        const searchOptions = {
          countries: ['SWE', 'FIN'], // Alpha-3 country codes
          maxResults: 10, // 50 is the max and the default
        }
        const filteredData = await Geo.searchByText(text, searchOptions)
        this.filteredOptions = [{
          data: filteredData,
        }]
      }
    },
  },
}
</script>

<style>

</style>
